export default "__VITE_ASSET__DouhKZFo__"